<script setup>
  import { ref, defineProps, onMounted, nextTick, defineEmits, watch  } from "vue";
  import { isEnableShopify } from "@/hooks/shopify-hooks/useShopifyConst";
  import ReactPrice from "@/components/basic/react-components/price/Index.vue";
  
  const emits = defineEmits(["priceLoaded","dataChanged"]);
  const props = defineProps({
    stateKey: {
      type: String,
      default: "",
    },
    node: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dataset: {
      type: Object,
      default: () => {
        return {};
      },
    },
  });
  const shopifyPrice = ref(null);
  const hasShopifysalePrice = ref(false);
  

  onMounted(async () => {
    if (!isEnableShopify) {
      nextTick(()=>{
        emits("priceLoaded")
      })
      return false;
    }
  });
  
  
  
  const handlePriceChange = ({ price, salePrice, discount}) => {
    shopifyPrice.value = {
      discountPrice: price?.formattedPrice,
      productPrice: salePrice?.formattedPrice,
      discountAmount: discount?.formattedPrice,
    }
  }


  watch(() => props.node, (newVal) => {
    if(newVal){
      hasShopifysalePrice.value = true;
    }
  }, { immediate: true })
  
  </script>
  
  <template>
    <div class="csr-cp-price-v1__styles">
      <!-- 购物车shopify的价格显示 -->
      <div v-if="hasShopifysalePrice" class="csr-cp-price-v1">
        <ReactPrice :variant="node" :is-cart="true"  @price-change="handlePriceChange" />
        <template>
          <div class="csr-cp-price-v1-sale csr-commerce-price">
            {{ shopifyPrice?.discountPrice }}
          </div>
          <div
            class="csr-cp-price-v1-original"
            v-if="shopifyPrice?.productPrice || shopifyPrice?.discountAmount"
          >
            <span class="csr-cp-price-v1-original-cost csr-commerce-price" v-if="shopifyPrice?.productPrice && shopifyPrice?.discountAmount">
              {{ shopifyPrice?.productPrice }}
            </span>
            <span  class="csr-cp-price-v1-original-ratio" v-if="shopifyPrice?.discountAmount">
              <span :class="dataset.saveTo?'originalRatioRight4':''">{{ dataset.saveTo }}</span>
              <span class="csr-commerce-price">{{ shopifyPrice?.discountAmount }}</span>
            </span>
          </div>
        </template>
      </div>
    </div>
  </template>
  